/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { mediaControllerGetMedia } from '../fn/media/media-controller-get-media';
import { MediaControllerGetMedia$Params } from '../fn/media/media-controller-get-media';

@Injectable({ providedIn: 'root' })
export class MediaService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `mediaControllerGetMedia()` */
  static readonly MediaControllerGetMediaPath = '/media';

  /**
   * Recupera un elemento da bucket.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `mediaControllerGetMedia()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetMedia$Response(params: MediaControllerGetMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return mediaControllerGetMedia(this.http, this.rootUrl, params, context);
  }

  /**
   * Recupera un elemento da bucket.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `mediaControllerGetMedia$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  mediaControllerGetMedia(params: MediaControllerGetMedia$Params, context?: HttpContext): Observable<Blob> {
    return this.mediaControllerGetMedia$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
